import { Box, Container, styled, Typography } from "@mui/material";
import { blue, grey } from "@mui/material/colors";

import { FONDLogo } from "fond/svg_icons";

export const PageContainer = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;

  & #banner-slot {
    position: relative;
    width: 100%;
  }

  &::before,
  &::after {
    position: fixed;
    content: "";
    display: block;
    z-index: -1;
    filter: blur(200px);
  }

  &::before {
    --width: 1850px;
    --height: 500px;
    background-color: #d7d7d7;
    border-radius: var(--width);
    bottom: calc(var(--height) / 2 * -1);
    height: var(--height);
    width: var(--width);
  }

  &::after {
    --diameter: 1100px;
    --visible: 100px;
    background-color: ${blue[400]};
    border-radius: var(--diameter);
    bottom: calc(var(--visible) - var(--diameter));
    height: var(--diameter);
    opacity: 0.5;
    width: var(--diameter);
  }
`;

export const Description = styled(Box)(({ theme }) => ({
  color: grey[700],
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(4),
}));

export const Logo = styled(FONDLogo)({
  height: 45,
  width: "auto",
});

export const IconContainer = styled(Container)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

export const Title: React.FC<React.ComponentProps<typeof Typography>> = (props) => <Typography variant="h2" {...props} />;

export const TopBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

export const Top = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(5),
  [theme.breakpoints.down("md")]: {
    paddingLeft: "10vw", // 10 on each side to add up to 20 (same as Content)
    paddingRight: "10vw",
  },
  [theme.breakpoints.up("md")]: {
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
}));
